/**
 * 敏感词
 */
import request from '@/utils/request';

// 新增修改敏感词
export function demandsensitivewordsCreate(option) {
  return request({
    url: `/op/demandsensitivewords/create`,
    method: 'post',
    data: option
  });
}
// 敏感词获取详细信息
export function demandsensitivewordsGet(option) {
  return request({
    url: `/op/demandsensitivewords/get`,
    method: 'get',
    params: option
  });
}
// 校验敏感词
export function demandsensitivewordsCheck(option) {
  return request({
    url: `/op/demandsensitivewords/check`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    data: option
  });
}
